import PosCartActions from '../../actions/PosCartActions';
import NotificationActions from '../../actions/NotificationActions';
import GuestActions from '../../actions/GuestActions';
import PosActions from '../../actions/PosActions';
import PopupActions from '../../actions/PopupActions';

import GuestStore from '../../stores/GuestStore';
import UserStore from '../../stores/UserStore';
import PosCartStore from '../../stores/PosCartStore';
import PosStore from '../../stores/PosStore';
import ConfigStore from '../../stores/ConfigStore';

import AjaxPromises from '../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../constants/PosConstants';

// import GuestList from '../guest-list/GuestList.react';
import PosHeader from './PosHeader.react';
import PosMain from './PosMain.react';
import PosSidebar from './sidebar/PosSidebar.react';
import PosNotification from './notification/PosNotification.react';

import KeyupBarcodeScanner from '../scanner/KeyUpBarcodeScanner.react';
import BarcodeScanner from '../scanner/BarcodeScanner.react';

class Pos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            guest_id: this.props.route[1],
            guest: false,

            page: 'cart',
            query: '',
            searchText: '',

            notification: [],

            searchResults: [],

            cart: [],
            allotment: false,
            preOrders: [],

            productHistory: [],
            transactionHistory: [],

            selected: false,
            appliedDiscounts: [],

            appliedFeesDonations: [],

            scan: false,
            promtKeyCode: false,
            weight: false,

            bulk: false,
            item: false,

            appliedLoyaltyPoints: false,

            count: 0,

            productList: PosStore.getState().productList,
            categoryList: PosStore.getState().categoryList,
            masterCategoryList: PosStore.getState().masterCategoryList,
            byStrain: PosStore.getState().byStrain,
            searchFocused: false,
            remotePayInfo: false,
        };

        this.onGuestStoreChange = this.onGuestStoreChange.bind(this);
        this.onPosStoreSearch = this.onPosStoreSearch.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.onPosCartStoreChange = this.onPosCartStoreChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.scan = this.scan.bind(this);
        this.updateSearchText = this.updateSearchText.bind(this);
    }

    componentWillMount() {
        // GuestActions.loadFullGuest(this.props.route[1]);
    }

    updateSearchText(text) {
        this.setState({ searchText: text });
    }

    componentDidMount() {
        GuestStore.addChangeListener(this.onGuestStoreChange);
        PosStore.addChangeListener(this.onPosStoreChange);
        PosStore.addSearchListener(this.onPosStoreSearch);
        PosCartStore.addChangeListener(this.onPosCartStoreChange);

        GuestActions.loadFullGuest(this.props.route[1]);
        PosActions.productSearch(UserStore.getApiData(), this.state.guest_id);
    }

    componentWillUnmount() {
        GuestStore.removeChangeListener(this.onGuestStoreChange);
        PosStore.removeChangeListener(this.onPosStoreChange);
        PosStore.removeSearchListener(this.onPosStoreSearch);
        PosCartStore.removeChangeListener(this.onPosCartStoreChange);

        this.setState({ guest: false });
    }

    onPosStoreSearch() {
        this.setState({
            productList: PosStore.getState().productList,
            searchResults: PosStore.getState().searchResults,
            categoryList: PosStore.getState().categoryList,
            masterCategoryList: PosStore.getState().masterCategoryList,
            byStrain: PosStore.getState().byStrain,
        });
    }

    onSearch(page, query) {
        let toPage = page || this.state.page;

        if (!toPage || toPage == 'cart') {
            toPage = 'productSearch';
        }

        this.setState({
            page: toPage,
            query: query,
            searchText: query,
        });
    }

    onGuestStoreChange() {
        let self = this;
        let guest = GuestStore.getGuestById(this.props.route[1]);
        let notification = [];

        if ((!this.state.guest || !GuestStore.getState().showCollector) && guest) {
            let guestId = this.props.route[1];

            PosCartActions.loadUserCart(guestId, guest.ShipmentId);

            if (guest.status.toLowerCase() !== 'active')
                notification.push({ header: 'ALERT', body: 'Current status is: ' + guest.status });
            if (
                PosStore.getState().popUpNotes &&
                !(UserStore.getState().selectedLocation.UseMn && GuestStore.getState().showCollector)
            ) {
                if (UserStore.getState().selectedLocation.PopUpJournal) {
                    PopupActions.patientJournal(guest);
                } else if (guest.notes && guest.notes.length > 0) {
                    notification.push({ header: 'Notes', body: guest.notes });
                }
            }

            if (
                UserStore.getState().selectedLocation.POSNoteUnder18 &&
                (moment().diff(guest.DOB, 'years', true) < 18 || !moment(guest.DOB).isValid())
            ) {
                notification.push({ header: 'ALERT', body: 'Patient DOB not valid or patient is under 18' });
            } else if (
                UserStore.getState().selectedLocation.POSNoteUnder21 &&
                (moment().diff(guest.DOB, 'years', true) < 21 || !moment(guest.DOB).isValid())
            ) {
                notification.push({ header: 'ALERT', body: 'Patient DOB not valid or patient is under 21' });
            }

            if (
                UserStore.getState().selectedLocation.Attestation &&
                guest &&
                guest.Attestation == 'yes' &&
                guest.AttestationExpirationDate
            ) {
                let attExpiration = moment(guest.AttestationExpirationDate);
                let currentDate = moment();
                let difference = attExpiration.diff(currentDate, 'days');

                if (difference <= 30 && difference > 0) {
                    notification.push({ header: 'ALERT', body: `Patient attestation expires in ${difference} day(s)` });
                }

                if (
                    moment().isAfter(guest.AttestationExpirationDate, 'day') ||
                    moment().isSame(guest.AttestationExpirationDate, 'day')
                ) {
                    notification.push({ header: 'ALERT', body: `Patient attestation has expired` });
                }
            }

            if (guest.PatientType === 'Medical') {
                setTimeout(() => {
                    PosActions.setSidebarPage('profile');
                    PosActions.toggleSidebar('open');
                }, 10);
            }
        }
        this.setState({
            guest: guest,
            notification: notification,
        });
    }

    onPosCartStoreChange() {
        this.setState(
            {
                cart: PosCartStore.getState().cart,
                allotment: PosCartStore.getAllotment(this.state.guest),
                preOrders: PosCartStore.getState().preOrders,
                appliedDiscounts: PosCartStore.getState().appliedDiscounts,
                appliedFeesDonations: PosCartStore.getState().appliedFeesDonations,
                remotePayInfo: PosCartStore.getState().remotePayInfo,
            },
            () => {
                // self.checkLoyaltyAmount();
            }
        );
    }

    onPosStoreChange() {
        var store = PosStore.getState();

        this.setState({
            productHistory: _.sortBy(store.productHistory, 'PosDate'),
            transactionHistory: _.sortBy(store.transactionHistory, 'PosDate'),
            appliedLoyaltyPoints: store.appliedLoyaltyPoints,
        });
    }

    scan(barcode, query) {
        var self = this;

        var trimBarcode = barcode.replace(/^[^a-zA-Z0-9]*|[^a-zA-Z0-9]*$/g, '');

        // dont allow scan if notification is blocking the screen
        if (this.state.notification.length > 0) return;

        if ($('.checkout').length) return;

        // GREEN HOUSE 1041
        // compensate for scanner, it adds '2' in front of some barcodes
        if (UserStore.getApiData().LspId == 1041 && trimBarcode.length === 17 && trimBarcode[0] == 2)
            trimBarcode = trimBarcode.substr(1);

        var formData = UserStore.getApiData({
            SerialNumber: trimBarcode.toString(),
            CustomerId: this.state.guest.Guest_id,
        });

        if (query) {
            this.setState({ query: trimBarcode });
        }

        AjaxPromises.POST(PosEndPoints.SCAN_PRODUCT, formData).then((res) => {
            if (!res.Result || !res.Data || res.Data.length !== 1) {
                NotificationActions.addNotification({
                    type: 'alert',
                    body: 'Could not find product',
                });
            } else {
                if (res.Data[0].ProductType === 'Qty') {
                    PosCartActions.addItemToCart(res.Data[0], self.state.guest, 1);
                } else {
                    PopupActions.addBulk(self.state.guest, res.Data[0]);
                }
            }
        });
    }

    render() {
        var route = this.props.route;
        var guest = this.state.guest;
        var page = this.state.page;
        var cart = this.state.cart;
        var preOrders = this.state.preOrders;
        var allotment = this.state.allotment || [];
        var query = this.state.query;
        const remotePayInfo = this.state.remotePayInfo;

        var searchResults = this.state.productList.filter((x) => {
            return (
                x.ProductDesc.toLowerCase().indexOf(query.trim().toLowerCase()) >= 0 ||
                x.ProductNo.toLowerCase().indexOf(query.trim().toLowerCase()) >= 0 ||
                x.SerialNo.toLowerCase().indexOf(query.trim().toLowerCase()) >= 0
            );
        });

        return (
            <div id='pos' className='pos'>
                <PosHeader
                    guest={guest}
                    page={page}
                    cart={cart}
                    appliedDiscounts={this.state.appliedDiscounts}
                    appliedFeesDonations={this.state.appliedFeesDonations}
                    preOrders={preOrders}
                    setPage={(page) => {
                        this.setState({ page });
                    }}
                    onSearch={this.onSearch}
                    searchText={this.state.searchText}
                    updateSearchText={this.updateSearchText}
                    onSearchFocus={(searchFocused) => this.setState({ searchFocused })}
                />

                <PosSidebar
                    guest={guest}
                    cart={cart}
                    preOrders={preOrders}
                    appliedLoyaltyPoints={this.state.appliedLoyaltyPoints}
                    appliedDiscounts={this.state.appliedDiscounts}
                    appliedFeesDonations={this.state.appliedFeesDonations}
                    allotment={allotment}
                    setPage={(page) => {
                        this.setState({ page });
                    }}
                    onSearch={this.onSearch}
                />

                <PosMain
                    guest={guest}
                    cart={this.state.cart}
                    page={this.state.page}
                    searchResults={searchResults}
                    productList={this.state.productList}
                    remotePayInfo={this.state.remotePayInfo}
                    query={query}
                    byStrain={this.state.byStrain}
                    appliedLoyaltyPoints={this.state.appliedLoyaltyPoints}
                    appliedDiscounts={this.state.appliedDiscounts}
                    categoryList={PosStore.getState().categoryList}
                    masterCategoryList={PosStore.getState().masterCategoryList}
                    strainList={PosStore.getState().strainList}
                    allotment={allotment}
                    preOrders={preOrders}
                    onSearch={this.onSearch}
                />
                {!this.state.searchFocused && (
                    <div>
                        {UserStore.getState().selectedLocation.UseKeyupBarcodeScanner ? (
                            <KeyupBarcodeScanner stopPropagation onScan={this.scan} />
                        ) : (
                            <BarcodeScanner onScan={this.scan} />
                        )}
                    </div>
                )}
                <PosNotification
                    notification={this.state.notification}
                    onClear={(notes) => {
                        this.setState({ notification: notes });
                    }}
                />
            </div>
        );
    }
}

export default Pos;

// this.setState({ sidebarMenu : (this.state.sidebarMenu === page ? false : page) })



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/Pos.react.jsx